module.exports = __webpack_public_path__ + "img/bg-servicios-5.63f0cb34.png";